import api from '@edu-fe/api'

export default {
  name: 'freeVideo',
  namespaced: true,
  state: {
    courseList: [], // 免费课程列表
    searchResult: [], // 搜索列表
    selectedCourse: {} // 搜索选中的课程
  },
  mutations: {
    setCourseList: (state, list) => (state.courseList = list),
    resetCourseList: state => (state.courseList = []),
    setSearchResult: (state, list) => (state.searchResult = list),
    resetSearchResult: state => (state.searchResult = []),
    remainSelectedCourse: (state, course) => (state.selectedCourse = course),
    resetSelectedCourse: state => (state.selectedCourse = {}),
    unshiftCourse: (state, course) => state.courseList.unshift(course)
  },
  actions: {
    getCourseList ({ state, commit }, { pageNo = 1, pageSize = 10 }) {
      return api.freeVideo.getData({
        category: '',
        pageNo,
        pageSize
      }).then(res => {
        const list = state.courseList.concat(res.data.list)
        // list.length = pageSize * pageNo

        if (state.selectedCourse.id) {
          // 判断当前列表是否已经存在选中的视频
          const hasThisCourse = list.filter(course => course.id === state.selectedCourse.id).length
          if (!hasThisCourse) {
            // 将搜索选择的课程添加到首位
            list.unshift(state.selectedCourse)
          }

          commit('setCourseList', list)
          commit('resetSelectedCourse')
        } else {
          commit('setCourseList', list)
        }
      }).catch(err => console.error(err))
    },
    getCourseDetail ({ state, commit }, id) {
      return api.freeVideo.detail({
        id
      }).then(res => {
        commit('unshiftCourse', res.data)
        return res.data
      })
    },
    search ({ commit }, title) {
      api.freeVideo.search({
        pageNo: 1,
        pageSize: 10,
        title
      }).then(res => {
        commit('setSearchResult', res.data)
      }).catch(err => console.error(err))
    }
  }
}
